/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { authorAlbumCollectionModelSchema } from "./authorAlbumCollectionModelSchema.ts";
import { fileModelSchema } from "./fileModelSchema.ts";
import { z } from "zod";

export const albumCollectionItemModelSchema = z.object({
    "id": z.string().uuid().describe("Идентификатор"),
"name": z.string().describe("Наименование"),
"number": z.number().int().describe("Порядковый номер"),
"picture": z.lazy(() => fileModelSchema).describe("Обложка").nullable().nullish(),
"authors": z.array(z.lazy(() => authorAlbumCollectionModelSchema)).describe("Авторы")
    })